import React, { useState, useEffect } from "react";
import axios from "axios";

export default function EkycDetails({ uidOrRc }) {
  const [data, setData] = useState([]);
  const [message, setMessage] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  useEffect(() => {
    if (uidOrRc) searchData(uidOrRc);
  }, [uidOrRc]);

  const searchData = async (uid) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/api/ekyc/search`, {
        uidOrRc: uid,
      });
      const fetchedData = res.data?.data || [];
      setData(fetchedData);
      setMessage(fetchedData.length === 0 ? `No details found for ${uid}` : "");
      setAlertMsg(""); // clear any previous alert when searching new UID
    } catch (err) {
      console.error(err);
      setMessage("Error fetching data");
    }
  };

  const handleRemove = async (row) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/api/remove`, {
        uid: row.uid,
        slno: row.slno,
      },
        {
          headers: {
            'X-React-Route': window.location.href
          }
        }

      );

      setData((prevData) => prevData.filter((r) => r.slno !== row.slno));

      const msg = res.data.message || "Removed successfully!";
      window.alert(msg);
      setAlertMsg(msg); // show message in UI

    } catch (err) {
      console.error(err);
      window.alert("Error removing eKYC");
      setAlertMsg("Error removing eKYC");
    }
  };

  return (
    <div className="p-4">
      {message && (
        <div className="mainhead" align="center">
          {message}
        </div>
      )}

      {alertMsg && (
        <div className="mainhead" align="center" >
          {alertMsg}
        </div>
      )}

      {data.length > 0 && (
        <table
          align="center"
          width="90%"
          border="1"
          cellPadding="5"
          cellSpacing="0"
        >
          <thead style={{ position: "sticky", top: 0 }}>
            <tr className="tableheader">
              <th colSpan={19}>UID eKYC Details</th>
            </tr>
            <tr className="tableheader">
              <th>District</th>
              <th>Office</th>
              <th>FPS Id</th>
              <th>RC No</th>
              <th>Member Id</th>
              <th>RC Member Name</th>
              <th>eKYC Name</th>
              <th>UID</th>
              <th>Last 4 UID</th>
              <th>eKYC Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr key={i}>
                <td>{row.dist_name_en}</td>
                <td>{row.afso_name_en}</td>
                <td>{row.port_fpsid}</td>
                <td>{row.existing_rc_number}</td>
                <td>{row.member_id}</td>
                <td>{row.rc_member_name}</td>
                <td>{row.poi_name}</td>
                <td>{row.uid}</td>
                <td>{row.last_4_uid}</td>
                <td>{row.updated_timestamp}</td>
                <td>
                  <button
                    className="bg-red-500 text-white px-2 py-1 rounded"
                    onClick={() => handleRemove(row)}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
